module.exports = __webpack_public_path__ + "img/bg.30732335.jpg";